import styled, { css } from "styled-components";
import getColor from "../../../../../utils/getColor";
import space from "../../../../../utils/space";
import { cellBackground, defaultCellPaddingSpace } from "../settings";
var Cell = styled.div.withConfig({
  componentId: "sc-rttxe-0"
})(function (_ref) {
  var theme = _ref.theme,
    $align = _ref.$align;
  return css(["display:flex;flex-basis:0;flex-flow:row nowrap;flex-grow:1;align-items:center;justify-content:", ";min-height:", ";padding:", ";background:", ";text-align:", ";"], $align || "center", space(5), space(defaultCellPaddingSpace), getColor(theme, cellBackground), $align || "center");
});
export default Cell;